<section class="section" id="pricing">
  <div class="wrap">
    <div class="section__head reveal">
      <span class="eyebrow">{{ 'LANDING.PRICING.EYEBROW' | translate }}</span>
      <h2>{{ 'LANDING.PRICING.TITLE' | translate }}</h2>
      <p>{{ 'LANDING.PRICING.SUBTITLE' | translate }}</p>
    </div>

    <!-- Loading skeletons -->
    @if (loading()) {
      <div class="pricing">
        @for (_ of [1, 2, 3]; track $index) {
          <div class="tier" style="opacity: 0.6">
            <div class="tier__skel tier__skel--name"></div>
            <div class="tier__skel tier__skel--price"></div>
            <div class="tier__skel tier__skel--desc"></div>
            <ul class="tier__feat" style="margin-top: 24px">
              @for (__ of [1, 2, 3, 4]; track $index) {
                <li>
                  <span
                    class="tier__skel"
                    style="width: 18px; height: 18px; border-radius: 999px; flex-shrink: 0"
                  ></span>
                  <div class="tier__skel" style="height: 14px; flex: 1; border-radius: 6px"></div>
                </li>
              }
            </ul>
            <div class="tier__skel tier__skel--cta"></div>
          </div>
        }
      </div>
    }

    <!-- Loaded plans -->
    @if (!loading()) {
      <div class="pricing">
        @for (plan of plans(); track plan.id; let i = $index) {
          <div
            class="tier tier--anim"
            [class.tier--featured]="isFeatured(i, plans().length)"
            [style.animationDelay]="i * 80 + 'ms'"
          >
            <!-- Popular badge -->
            @if (isFeatured(i, plans().length + 1)) {
              <div class="tier__badge">{{ 'LANDING.PRICING.POPULAR_BADGE' | translate }}</div>
            }

            <!-- Name -->
            <div class="tier__name">{{ localized(plan, 'name') || plan.name }}</div>

            <!-- Base price -->
            <div
              class="tier__price"
              [class.tier__price--has-discount]="
                activeDiscounts(plan).length > 0 && plan.monthlyPrice > 0
              "
            >
              @if (plan.monthlyPrice <= 0) {
                {{ 'LANDING.PRICING.FREE' | translate }}
              } @else {
                <span class="tier__price-num">{{ formatPrice(plan.monthlyPrice) }}</span>
                <small>{{ 'LANDING.PRICING.PER_MONTH' | translate }}</small>
              }
            </div>

            <!-- Best discounted price -->
            @if (activeDiscounts(plan).length > 0 && plan.monthlyPrice > 0) {
              <div class="tier__price-best">
                {{ bestDiscountedPrice(plan) }}
                <small>{{ 'LANDING.PRICING.PER_MONTH' | translate }}</small>
              </div>
            }

            <!-- Description -->
            @if (localized(plan, 'description'); as desc) {
              <div class="tier__desc">{{ desc }}</div>
            } @else {
              <div class="tier__desc">
                {{ formatStores(plan.maxStores) }} · {{ formatEmployees(plan.maxEmployees) }}
              </div>
            }

            <!-- Discounts — asil narx + chegirma ko'rinishi -->
            @if (activeDiscounts(plan).length > 0) {
              <div class="tier__discount-table">
                <div class="tier__discount-table-head">
                  {{ 'LANDING.PRICING.DISCOUNT_TABLE_HEAD' | translate }}
                </div>
                @for (d of activeDiscounts(plan); track d.id) {
                  <div class="tier__discount-row">
                    <div class="tier__discount-meta">
                      <span class="tier__discount-when">{{ discountLabel(d) }}</span>
                      @if (d.description) {
                        <span class="tier__discount-hint">{{ d.description }}</span>
                      }
                    </div>
                    <div class="tier__discount-price">
                      <span class="tier__discount-orig">{{ formatPrice(plan.monthlyPrice) }}</span>
                      <span class="tier__discount-arrow">→</span>
                      <span class="tier__discount-new">{{
                        discountedPrice(plan.monthlyPrice, d.discountPercent)
                      }}</span>
                      <span class="tier__discount-pct">−{{ d.discountPercent }}%</span>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Features -->
            <ul class="tier__feat">
              @if (plan.maxStores > 0 || plan.maxEmployees > 0) {
                <li>
                  <span>✓</span>
                  {{ formatStores(plan.maxStores) }}, {{ formatEmployees(plan.maxEmployees) }}
                </li>
              }
              @if (plan.maxProducts > 0) {
                <li>
                  <span>✓</span>
                  {{ formatProducts(plan.maxProducts) }}
                </li>
              }
              @for (mod of plan.includedModules; track mod) {
                <li><span>✓</span> {{ mod }}</li>
              }
            </ul>

            <button class="tier__cta" (click)="scrollTo('apply')">{{ ctaLabel(plan) }}</button>
          </div>
        }
      </div>
    }
  </div>
</section>
